var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudIndex',{attrs:{"title":"Project Statuses","viewColumns":_vm.columns,"fetchUrl":"/project-statuses","createUrl":"/project-statuses","updateRootUrl":"/project-statuses","deleteRootUrl":"/project-statuses","reloadOnSuccess":true,"createFields":_vm.createFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }